var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignatureIconSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#FFCC00",
    cx: 9.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(0.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02962051,9.01249641 L5.61206154,11.266281 C5.59081026,11.3811528 5.64192821,11.4983221 5.74129231,11.5609272 C5.84065641,11.6241067 5.9681641,11.6195118 6.06350769,11.5511631 L7.9198359,10.2071631 L6.02962051,9.01249641 Z",
    id: "Fill-4864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4865",
    points: "9.40484103 3.49916718 6.25792821 8.47771077 8.30436923 9.77059282 11.4512821 4.79262359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6185682,3.09165949 C13.9218297,2.61149538 13.8419938,1.99922872 13.4640656,1.60636718 L13.5772144,1.42716718 C13.6622195,1.29334154 13.6220144,1.11643897 13.4881887,1.03085949 L11.9282297,0.0446851282 C11.7938297,-0.04032 11.6169272,-0.000114871795 11.5319221,0.133710769 L9.71177846,3.01297231 L11.7576451,4.30700308 L13.136681,2.12443897 C13.2532759,2.3243159 13.2647631,2.57703385 13.1332349,2.78495179 L11.1603118,5.90716718 C11.0753067,6.04156718 11.1160862,6.21846974 11.2499118,6.30347487 C11.3837374,6.38848 11.5612144,6.34827487 11.6456451,6.21387487 L13.6185682,3.09165949 Z",
    id: "Fill-4866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37226667,11.5713231 L4.51072821,10.7097846 C4.39872821,10.5977846 4.21665641,10.5977846 4.10465641,10.7097846 L3.15868718,11.6551795 L2.21329231,10.7097846 C2.10129231,10.5977846 1.91922051,10.5977846 1.80722051,10.7097846 L0.0841435897,12.4328615 C-0.0284307692,12.5448615 -0.0278564103,12.7269333 0.0841435897,12.8389333 C0.19614359,12.9509333 0.377641026,12.9509333 0.490215385,12.8389333 L2.00996923,11.3186051 L2.95593846,12.2645744 C3.06793846,12.3765744 3.25001026,12.3765744 3.36201026,12.2645744 L4.30740513,11.3186051 L4.96619487,11.9773949 C5.07819487,12.0893949 5.26026667,12.0893949 5.37226667,11.9773949 C5.48426667,11.8653949 5.48426667,11.6833231 5.37226667,11.5713231",
    id: "Fill-4867"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#FFCC00",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(0.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02962051,9.01249641 L4.61206154,11.266281 C4.59081026,11.3811528 4.64192821,11.4983221 4.74129231,11.5609272 C4.84065641,11.6241067 4.9681641,11.6195118 5.06350769,11.5511631 L6.9198359,10.2071631 L5.02962051,9.01249641 Z",
    id: "Fill-4864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4865",
    points: "8.40484103 3.49916718 5.25792821 8.47771077 7.30436923 9.77059282 10.4512821 4.79262359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6185682,3.09165949 C12.9218297,2.61149538 12.8419938,1.99922872 12.4640656,1.60636718 L12.5772144,1.42716718 C12.6622195,1.29334154 12.6220144,1.11643897 12.4881887,1.03085949 L10.9282297,0.0446851282 C10.7938297,-0.04032 10.6169272,-0.000114871795 10.5319221,0.133710769 L8.71177846,3.01297231 L10.7576451,4.30700308 L12.136681,2.12443897 C12.2532759,2.3243159 12.2647631,2.57703385 12.1332349,2.78495179 L10.1603118,5.90716718 C10.0753067,6.04156718 10.1160862,6.21846974 10.2499118,6.30347487 C10.3837374,6.38848 10.5612144,6.34827487 10.6456451,6.21387487 L12.6185682,3.09165949 Z",
    id: "Fill-4866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51072821,10.7097846 C3.39872821,10.5977846 3.21665641,10.5977846 3.10465641,10.7097846 L2.15868718,11.6551795 L1.21329231,10.7097846 C1.10129231,10.5977846 0.919220513,10.5977846 0.807220513,10.7097846 L1.00996923,11.3186051 L1.95593846,12.2645744 C2.06793846,12.3765744 2.25001026,12.3765744 2.36201026,12.2645744 L3.30740513,11.3186051 L3.96619487,11.9773949 C4.07819487,12.0893949 4.26026667,12.0893949 4.37226667,11.9773949 C4.48426667,11.8653949 4.48426667,11.6833231 4.37226667,11.5713231 L3.51072821,10.7097846 Z",
    id: "Fill-4867"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignatureIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signature_icon_small.b0ebadd27cb5018b82a849f682b3ef02.svg";